import styled from 'styled-components';

export const Divider = styled.div`
  border-bottom: 1px solid #e8e8e8;
  margin: 16px 0px;
`;

export const WrapProducts = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export const ResultsPageTitle = styled.div`
  font-weight: 500;
  font-size: 24px;
  line-height: 30px;
  /* identical to box height, or 125% */

  letter-spacing: -0.48px;
  color: #0f1617;
  margin-bottom: 16px;
`;

export const ProductResultContainer = styled.div`
  background: #ffffff;
  box-shadow: 0px 0px 24px -8px rgba(143, 143, 143, 0.5);
  border-radius: 8px;
  width: 40%;
  margin-bottom: 20px;
  box-sizing: border-box;
  padding: 16px;
  margin: 8px;
  align-self: flex-start;
  cursor: pointer;

  @media (max-width: 580px) {
    width: 100%;
  }
`;

export const Columns = styled.div`
  display: flex;
`;

export const OverallRecommendation = styled.div`
  width: 80px;
`;

export const ReviewMetadata = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  /* or 133% */

  letter-spacing: -0.2px;

  color: #666666;
  margin-top: 10px;
`;

export const MatchedCount = styled.div`
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
  /* identical to box height, or 133% */

  letter-spacing: -0.2px;

  color: #0f1617;
  margin-bottom: 16px;
`;

export const AttributeTable = styled.div`
  display: flex;
`;

export const AttributeColumn = styled.div``;

export const AttributeTableRow = styled.div`
  display: flex;
  line-height: 13px;
  margin-bottom: 4px;
`;

export const AttributeName = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  letter-spacing: -0.2px;
  color: #0f1617;
  align-self: center;
  margin-left: 8px;
`;
